import type { RecoveryStatus as RecoveryStatusModel } from '../recovery';

export interface RecoveryStatusProps {
  readonly status: RecoveryStatusModel;
  readonly onRetry?: () => void;
}

export function RecoveryStatus({ status, onRetry }: RecoveryStatusProps) {
  const showRetry = status.state === 'FAILED' && onRetry !== undefined;
  return (
    <aside
      class={`recovery-status recovery-status--${status.state.toLowerCase()}`}
      role={status.state === 'FAILED' ? 'alert' : 'status'}
      aria-live={status.state === 'FAILED' ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <span class="recovery-status__indicator" aria-hidden="true" />
      <span class="recovery-status__message">{status.message}</span>
      {showRetry ? (
        <button class="recovery-status__retry" type="button" onClick={onRetry}>
          Try again
        </button>
      ) : null}
    </aside>
  );
}
